import formatRepliersImageSource from '@th/shared/src/helpers/formatRepliersImageSource';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import BlurText from './BlurText';
import ListingSpaceSummary from './listingDetails/ListingSpaceSummary';
import ListingAddress from './listingDetails/ListingAddress';
import useIsListingBlurred from '../hooks/useIsListingBlurred';
import { BlurImg } from './BlurImg';
import UnauthenticatedCarouselOverlay from './listingDetails/UnauthenticatedCarouselOverlay';
import ListingInfoBadge from './listingDetails/ListingInfoBadge';
import { twMerge } from 'tailwind-merge';

type Props = {
  listing: SimpleListing;
  zoomOnHover: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export default function ListingPreviewCard({
  listing,
  zoomOnHover,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  const image = listing.images[0]
    ? formatRepliersImageSource(listing.images[0], 'medium')
    : { uri: '/images/imagePlaceholder.png' };

  const isDetailsBlurred = useIsListingBlurred(listing);
  return (
    <div
      key={listing.id}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="group flex-col items-start"
    >
      <div className="relative object-cover align-bottom aspect-3/2 overflow-hidden rounded-lg">
        <BlurImg
          id={image.uri}
          src={image.uri}
          alt={`Preview image for ${listing.address.formattedAddressShortOneLiner()}`}
          key={image.uri}
          width={296}
          height={198}
          blurhash={listing.blurhashes?.[0]}
          className={twMerge(
            'object-cover align-bottom aspect-3/2 ',
            zoomOnHover && 'transition-all group-hover:scale-110',
          )}
        />

        {isDetailsBlurred && <UnauthenticatedCarouselOverlay small={true} />}
        <ListingInfoBadge listing={listing} enabled={false} />
      </div>
      <div className="pt-2 pb-1 ">
        <div className="flex flex-row items-center">
          <h4 className={'font-medium'}>
            <BlurText isBlurred={isDetailsBlurred}>
              {listing.displayPrice()}
            </BlurText>
          </h4>
        </div>
        <div className="my-1">
          <ListingSpaceSummary
            listing={listing}
            isBlurred={isDetailsBlurred}
            includeSqft={false}
            textClassName={'text-sm font-light'}
          />
        </div>
        <ListingAddress
          listing={listing}
          isBlurred={isDetailsBlurred}
          className={'text-sm font-light mt-0 mb-0 text-start'}
        />
      </div>
    </div>
  );
}
